import script from "./PremiumDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./PremiumDialog.vue?vue&type=script&setup=true&lang=js"

import "./PremiumDialog.vue?vue&type=style&index=0&id=06e928c5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06e928c5"]])

export default __exports__